import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowUp = (props) => (
  <Icon viewBox="0 0 360 227.3" {...props}>
    <g>
      <path fill="currentColor" d="M358 180.2l-44.3 43L183.4 89.1 45.3 223.2l-43-44.3L180.7 7.4l4.9-4.8z" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowUp;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowUp.js